import PageContain from "@/views/components/PageContain.vue";

import { VBtn, VMenu, VList, VListItem, VListItemTitle } from "vuetify/lib";
import VPage from "@/vuetify_custom/v-pagination";
import {
  getSellOrderQueryMineApi,
  getSellOrderEsQueryApi,
  getSellOrderDetailApi,
  downloadTemplateFileApi,
  postSellOrderDownImportItemsApi,
  sellOrderDeleteApi,
} from "./services";
import SearchBar from "./SearchBar";
import SearchBarFin from "./SearchBarFin";
import CreateResellOrderModel from "./CreateResellOrderModel/CreateResellOrderModel";
import VTable from "@/vuetify_custom/v-table/v3";
import UserFlowBase from "@/views/components/flow/user_flow_base_jsx_v1";
import ResellOrderDetailModal from "./ResellOrderDetailModal";
import CreateDeliverOrder from "./CreateDeliverOrder";
import ImportSkuModal from "./ImportSkuModal";
import FinishModel from "./FinishModel";
import DelModel from "./DelModel";
import {
  SellOrderStatusMap as statusTextMap,
  SellOrderStatusList as statusTextList,
  SellOrderDisallowCompleteStatusList,
  SellOrderDisallowDeleteStatusList,
} from "./constants";

export default {
  props: {
    type: {
      type: Number, // 1业务 ,2财务
      default: 1,
    },
  },
  data() {
    const searchParams = {};
    if (this.type === 1) {
      searchParams.search = "";
      searchParams.search_type = "pending";
    } else if (this.type === 2) {
      searchParams.flow_node_id = null;
      searchParams.user_flow_node_status = -1;
      searchParams.search = "";
    }

    return {
      searchParams: searchParams,
      pagination: {
        page: 1,
        per_page: 10,
        total_count: 0,
      },
      list: [],
      currentOrderId: null,
      loading: false,
      uploadId: null,
    };
  },
  computed: {
    table_fields() {
      return [
        { text: "名称", value: "name" },
        { text: "合同", value: "contract_code" },
        { text: "订单号", value: "uid" },
        { text: "订单备注", value: "memo" },
        { text: "申请人", value: "apply_customer_name" },
        {
          text: "状态",
          value: "status",
          render: (_, row) => {
            const statusText = statusTextMap[row.status];
            return <div>{statusText || "-"}</div>;
          },
        },
        { text: "订单总金额", value: "total_price" },
        { text: "已收款金额", value: "total_receipt_amount" },
        {
          text: "流程",
          value: "user_flow",
          fixed: "right",
          width: 200,
          render: (_, row) => {
            return (
              <div>
                <UserFlowBase
                  modelC={row.user_flow}
                  user_flow={row.user_flow}
                  show_handles={true}
                  on={{
                    ["on-change"]: () => {
                      console.log("on-change");
                      this.search();
                    },
                  }}
                />
              </div>
            );
          },
        },
        {
          text: "操作",
          value: "operations",
          width: 150,
          fixed: "right",
          render: (_, row) => {
            const canEdit =
              row.user_flow.current_user_flow_node.flow_node_name ===
              "分销申请";

            return (
              <div>
                <div>
                  <VMenu
                    offset-y
                    close-on-click={true}
                    scopedSlots={{
                      activator: ({ on, attrs }) => (
                        <VBtn
                          {...attrs}
                          on={on}
                          color="primary"
                          small
                          style="margin: 10px 0;"
                        >
                          操作
                        </VBtn>
                      ),
                    }}
                  >
                    <VList>
                      <VListItem
                        key="detail"
                        on={{
                          click: () => {
                            this.$refs.resellOrderDetailModal.open(row.id);
                          },
                        }}
                      >
                        <VListItemTitle>详情</VListItemTitle>
                      </VListItem>
                      {canEdit && (
                        <VListItem
                          key="edit"
                          on={{
                            click: () => {
                              this.editOrder(row.id);
                            },
                          }}
                        >
                          <VListItemTitle>编辑</VListItemTitle>
                        </VListItem>
                      )}
                      <VListItem
                        key="createDeliverOrder"
                        on={{
                          click: () => {
                            this.createDeliverOrder(row.id);
                          },
                        }}
                      >
                        <VListItemTitle>创建发货通知</VListItemTitle>
                      </VListItem>
                      {!SellOrderDisallowCompleteStatusList.includes(
                        row.status
                      ) && (
                        <VListItem
                          key="finish"
                          on={{
                            click: () => {
                              this.$refs.finishModel.open(row.id);
                            },
                          }}
                        >
                          <VListItemTitle>完成</VListItemTitle>
                        </VListItem>
                      )}
                      {!SellOrderDisallowDeleteStatusList.includes(
                        row.status
                      ) && (
                        <VListItem
                          key="del"
                          on={{
                            click: () => {
                              this.$refs.delModel.open(row.id);
                            },
                          }}
                        >
                          <VListItemTitle>废弃</VListItemTitle>
                        </VListItem>
                      )}
                      <VListItem
                        key="importSku"
                        on={{
                          click: () => {
                            this.upload(row.id);
                          },
                        }}
                      >
                        <VListItemTitle>导入SKU</VListItemTitle>
                      </VListItem>
                    </VList>
                  </VMenu>
                </div>
              </div>
            );
          },
        },
      ];
    },
  },
  mounted() {},
  methods: {
    search() {
      this.loading = true;
      const mixedSearchParams = {
        ...this.searchParams,
        ...this.pagination,
      };
      (this.type === 1
        ? getSellOrderQueryMineApi(mixedSearchParams)
        : getSellOrderEsQueryApi(mixedSearchParams)
      )
        .then((res) => {
          this.list = res.list;
          this.pagination.total_count = res.total_count;
        })
        .catch((err) => {
          console.log(err);
          this.$Message.error("获取数据失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    add() {
      console.log("add");
      this.$refs.createResellOrderModel.edit();
    },
    editOrder(id) {
      getSellOrderDetailApi({ id: id }).then((res) => {
        this.$refs.createResellOrderModel.edit(res);
      });
    },
    createDeliverOrder(id) {
      this.$refs.createDeliverOrder.add(id);
    },
    editDeliverOrder(deliverOrder) {
      this.$refs.createDeliverOrder.edit(
        deliverOrder.sell_order_id,
        deliverOrder.id
      );
    },
    onDeliverOrderSuccess() {
      this.search();
      if (this.$refs.resellOrderDetailModal.dis) {
        this.$refs.resellOrderDetailModal.refresh();
      }
    },
    upload(id) {
      this.uploadId = id;
      this.el = document.createElement("input");
      this.el.setAttribute("type", "file");
      this.$refs.contain.appendChild(this.el);
      this.el.click();
      this.el.addEventListener("change", this.uploadFile);
    },
    uploadFile() {
      const file = this.el.files[0];
      const format = ["xlsx", "csv"];
      const arr = (format || []).map((item) => new RegExp(item + "$"));
      if (arr.some((item) => item.test(file.type) || item.test(file.name))) {
        if (file.name.indexOf("%") > -1) {
          this.$Modal.error({
            title: "提示",
            content: "文件名不能包含百分号%",
          });
          return;
        }
        this.$emit("start");
        this.uploading = true;
        const formData = new FormData();
        formData.append("data_file", file);
        formData.append("id", this.uploadId);
        postSellOrderDownImportItemsApi(formData).then((res) => {
          this.$emit("done", res);
          this.$Message.success("导入成功");
        });
      }
    },
    downloadTemplate() {
      console.log("downloadTemplate");
      downloadTemplateFileApi();
    },
  },
  render() {
    return (
      <div>
        <div class="contract-group-container">
          {this.type === 1 ? (
            <SearchBar
              ref="searchBar"
              on-search={this.search}
              on-add={this.add}
              v-model={this.searchParams}
              on-downloadTemplate={this.downloadTemplate}
            />
          ) : (
            <SearchBarFin
              ref="searchBarFin"
              on-search={this.search}
              on-add={this.add}
              v-model={this.searchParams}
              on-downloadTemplate={this.downloadTemplate}
            />
          )}
        </div>
        <div class="list-container">
          <VTable
            headers={this.table_fields}
            desserts={this.list}
            loading={this.loading}
          ></VTable>
        </div>
        <div class="pagination-container">
          <VPage
            current={this.pagination.page}
            total={this.pagination.total_count}
            page-size={this.pagination.per_page}
            size-arr={[10, 20, 50]}
            on={{
              changePageSize: (per_page) => {
                this.pagination.per_page = per_page;
                this.pagination.page = 1;
                this.$nextTick(this.search);
              },
              pageChange: (page) => {
                this.pagination.page = page;
                this.$nextTick(this.search);
              },
            }}
          />
        </div>
        <CreateResellOrderModel
          ref="createResellOrderModel"
          on-success={this.search}
        />
        <ResellOrderDetailModal
          ref="resellOrderDetailModal"
          on-edit={this.editDeliverOrder}
        />
        <CreateDeliverOrder
          ref="createDeliverOrder"
          on-success={this.onDeliverOrderSuccess}
        />
        <ImportSkuModal ref="importSkuModal" on-success={this.search} />
        <FinishModel ref="finishModel" on-success={this.search} />
        <DelModel
          ref="delModel"
          on-success={this.search}
          delApi={sellOrderDeleteApi}
        />
        <div ref="contain" style="visibility: hidden;"></div>
      </div>
    );
  },
};
